/*
 * // Created on 2024-03-14
 * // Created by Rodrigo Lyra
 * //
 * // Copyright (c) 2024 OPEN CASCADE SAS
 * //
 * // This file is part of commercial software by OPEN CASCADE SAS,
 * // furnished in accordance with the terms and conditions of the contract
 * // and with the inclusion of this copyright notice.
 * // This file or any part thereof may not be provided or otherwise
 * // made available to any third party.
 * //
 * // No ownership title to the software is transferred hereby.
 * //
 * // OPEN CASCADE SAS makes no representation or warranties with respect to the
 * // performance of this software, and specifically disclaims any responsibility
 * // for any damages, special or consequential, connected with its use.
 *
 */
import { Vec3Tools } from "../../../core/geometry/vec3-tools.js";
export class LinerCupUtilities {
    /**
     * Check validity of liner
     * @param theLinerInfo - liner info
     * @returns true if liner is valid
     */
    static isValidLiner(theLinerInfo) {
        return !Vec3Tools.isInfinite(theLinerInfo.rotationPoint) && !(theLinerInfo.scale <= 0);
    }
    /**
     * Check validity of shell
     * @param theShellInfo - shell info
     * @returns true if shell is valid
     */
    static isValidShell(theShellInfo) {
        return !Vec3Tools.isInfinite(theShellInfo.rotationPoint) && !(theShellInfo.scale <= 0);
    }
}
